import { useContext, useEffect } from "react";
import styles from "./ReferencesPage.module.css";
import DataContext from "../../store/data-context";
import PageAnimation from "../../Other/PageAnimation";

export default function ReferencesPage() {
  const dataCtx = useContext(DataContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageAnimation>
      <div className={styles.main}>
        <div className={styles.title}>{dataCtx.pageData.references.title}</div>
        {dataCtx.references !== -2 ? (
          <div className={styles.grid}>
            {dataCtx.references.map((references, key) => {
              return (
                <div key={key}>
                  <div className={styles[`references-title`]}>
                    {dataCtx.lang.lang === "hr"
                      ? references.title
                      : references.acf.title_de}
                  </div>
                  <div
                    key={key}
                    className={styles.references}
                    dangerouslySetInnerHTML={{
                      __html:
                        dataCtx.lang.lang === "hr"
                          ? references.content
                          : references.acf.description_de,
                    }}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <div>NO REFERENCES</div>
        )}
      </div>
    </PageAnimation>
  );
}
